import React, { Component } from 'react';



class View3dAPP extends Component {

//VR TOUR 3F MASTER SUITE

      render() {
        return(
            <div>
                <iframe width="100%" height="1084" frameborder="0" allow="xr-spatial-tracking; gyroscope; accelerometer" allowfullscreen scrolling="no" src="https://www.renderedreality.com.au/experience/lucia-experience/"></iframe>
             </div>
        );
      }
  }




export default View3dAPP;
//Photo by Sharon McCutcheon on Unsplash
//https://unsplash.com/photos/-vgLTTWPesg
